export default [
    {
        id: 1,
        label: 'Approved'
    },
    {
        id: 2,
        label: 'Pending'
    },
    {
        id: 3,
        label: 'Disapproved'
    }
]